import React from "react";
import "../../assets/css/question-template.css";
import { useDashboardContext } from "../../context/customhook/dashboardHook";

export default function QuestionItem({
  question,
  questionId,
  isParent,
  isSelected,
}) {
  const { dashboardStates, setDashboardStates } = useDashboardContext();

  const questionOnClick = (selectedValue) => {
    if (isParent) {
      //Update Question Selected
      const updatedQuestiondata = dashboardStates.parentQuestiondata.map(
        (obj) => ({
          ...obj,
          isSelected: obj.questionId === selectedValue ? true : false,
        })
      );

      // For Dynamic Questions Purpose
      let selectedQuestion;

      for (const element of dashboardStates.parentQuestiondata) {
        if (element.questionId === selectedValue) {
          selectedQuestion = element.questionName;
          break; // Exit the loop once the condition is met
        }
      }

      setDashboardStates((previousState) => {
        return {
          ...previousState,
          parentQuestionId: selectedValue,
          parentQuestion: selectedQuestion,
          childQuestionId: null,
          parentQuestiondata: updatedQuestiondata,
          childQuestiondata: null,
          showAdditionalFeedback: false,
        };
      });
    } else {
      const updatedQuestiondata = dashboardStates.childQuestiondata.map(
        (obj) => ({
          ...obj,
          isSelected: obj.questionId === selectedValue ? true : false,
        })
      );

      setDashboardStates((previousState) => {
        return {
          ...previousState,
          childQuestionId: selectedValue,
          childQuestiondata: updatedQuestiondata,
          showAdditionalFeedback: true,
        };
      });
    }
  };

  return (
    <button
      className={isSelected ? "question-button-selected" : "question-button"}
      onClick={() => questionOnClick(questionId)}
    >
      {question}
    </button>
  );
}
